var map = {
	"./": 3433,
	"./assets/contact_ico1.svg": 2875,
	"./assets/contact_ico2.svg": 6023,
	"./assets/contact_ico3.svg": 345,
	"./index": 3433,
	"./index.jsx": 3433,
	"./style.scss": 8620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9944;